import React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    Sheet,
    YStack,
} from 'smoothie';

import { type AccountSummary, Provider } from '../../types/HolisticSummary';

export interface Props {
    account: AccountSummary;
    isOpen: boolean;
    onClose: () => void;
    onSubmitDeleteAccount: (id: string, provider: Provider) => Promise<void>;
}

const ConfirmDeleteSheet = ({
    account,
    isOpen,
    onClose,
    onSubmitDeleteAccount,
}: Props) => {
    return (
        <Sheet isOpen={isOpen} onClose={onClose} showCloseButton={false}>
            <BodyMediumRegular textAlign="center">
                Are you sure you want to delete this account? The balance will
                be removed from all totals.
            </BodyMediumRegular>
            <YStack marginTop={12} gap={8}>
                <Button
                    variant={ButtonVariant.TERTIARY}
                    size={ButtonSize.LARGE}
                    text="Cancel"
                    onPress={() => {
                        onClose();
                    }}
                />
                <Button
                    variant={ButtonVariant.PRIMARY}
                    tone="danger"
                    size={ButtonSize.LARGE}
                    text="Delete this account"
                    onPress={async () => {
                        await onSubmitDeleteAccount(
                            account.id,
                            Provider.MANUAL,
                        );
                    }}
                />
            </YStack>
        </Sheet>
    );
};

export default ConfirmDeleteSheet;
